// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_g6-0";
export var headerCellHover = "_g6-1";
export var readCellContainer = "_g6-2";
export var searchHighlight = "_g6-4";
export var unreadIndicator = "_g6-3";